<script>
	import { onMount, createEventDispatcher } from "svelte";
	import { SupportUser,Response,isFormAlreadySubmitted } from "./store.js";
	import Steps from "./steps.svelte";
	import wrappedFetch from "../../wrappedFetch.js";
	let content;
    let isPageLoading = true;
    let showFooterButtons=true;
	const dispatch = new createEventDispatcher();
	const getContent = async () => {
		const getHelpContents = await wrappedFetch(
			"helpcontent?helpId=contactsupport"
		);
		let resp = await getHelpContents.json();
		return resp.filter((r) => r.type == "h2")[0].text;
	};

	const gotoNext = () => {
        $Response.step1=true;
		if ($SupportUser == null) {
            _paq.push(['trackEvent', 'SupportForm', `Sign in`]);
			dispatch("pageChange", "/signin?returnUrl=/support/step2");
        } else 
        {
            _paq.push(['trackEvent', 'SupportForm', `Signed in Next`]);
            dispatch("pageChange", "/support/step2");
    }
    };
    const continueNext = () => {
        $Response.step1=true;
        _paq.push(['trackEvent', 'SupportForm', `Continue without sign in`]);
        dispatch('change');
        dispatch("pageChange", "/support/step2");
    }
	onMount(async () => {
       
        if(!isFormAlreadySubmitted())
            content = await getContent();
            else 
            {
                content ='<p>We have received your query and will respond shortly. If you need to submit a different query, please try again later.</p>'
                showFooterButtons = false;
                dispatch("checkCookie");
            }
		isPageLoading = false;
	});
</script>

<Steps	
	buttonText={$SupportUser == null ? "Sign In":"Next"}
    bind:isPageLoading
    bind:showFooterButtons   
    on:handleNext={gotoNext}
    on:handleContinue={continueNext}
    backUrl={"/help"}
	showContinueWithoutSigninButton={$SupportUser == null}
	on:pageChange={(event) => dispatch('pageChange', event.detail)}>
    <div class="column">{@html content}</div>
</Steps>
